import type {FileResponse} from 'src/api/ProactApiClient';
import {adminApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery} from '../clientQuery';

export const adminApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    throwApiException: builder.mutation<FileResponse | null, void>({
      queryFn: clientQuery(() => adminApiClient.throwException()),
    }),
    throwValidationException: builder.mutation<FileResponse | null, void>({
      queryFn: clientQuery(() =>
        adminApiClient.throwValidationErrorException()
      ),
    }),
  }),
});

export const {
  useThrowApiExceptionMutation,
  useThrowValidationExceptionMutation,
} = adminApi;
